module.exports = __webpack_public_path__ + "img/info-circle-solid.d9a24d05.svg";